export default __webpack_public_path__ + "static/Gilroy-ExtraBold-5664d441cb73ee4910aee78f07cd704d.woff";